require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.set-prototype-of");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], t) : t((e = e || self)["react-dismissible"] = {}, e.React);
}(this, function (e, o) {
  "use strict";

  var _n = function n(e, t) {
    return (_n = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }
    })(e, t);
  };

  var _r = function r() {
    return (_r = Object.assign || function (e) {
      for (var t, n = 1, o = arguments.length; n < o; n++) {
        for (var r in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  var t,
      i,
      c,
      s = (c = o.Component, _n(t = a, i = c), void (t.prototype = null === i ? Object.create(i) : (p.prototype = i.prototype, new p())), Object.defineProperty(a.prototype, "documents", {
    get: function get() {
      var e = [document];
      return this.props.document && e.push(this.props.document), e;
    },
    enumerable: !0,
    configurable: !0
  }), a.prototype.componentDidMount = function () {
    var t = this;
    this.props.click && this.documents.forEach(function (e) {
      return e.body.addEventListener("click", t.handleDocumentClick);
    }), this.props.escape && this.documents.forEach(function (e) {
      return e.addEventListener("keydown", t.handleEscape);
    });
  }, a.prototype.componentWillUnmount = function () {
    var t = this;
    this.documents.forEach(function (e) {
      return e.body.removeEventListener("click", t.handleDocumentClick);
    }), this.documents.forEach(function (e) {
      return e.removeEventListener("keydown", t.handleEscape);
    });
  }, a.prototype.render = function () {
    var t = this,
        e = this.props,
        n = (e.onDismiss, e.click, e.escape, function (e, t) {
      var n = {};

      for (var o in e) {
        Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;

        for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) {
          t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
        }
      }

      return n;
    }(e, ["onDismiss", "click", "escape"]));
    return o.createElement("div", _r({
      ref: function ref(e) {
        return t.area = e;
      }
    }, n));
  }, a);

  function p() {
    this.constructor = t;
  }

  function a() {
    var t = null !== c && c.apply(this, arguments) || this;
    return t.handleDocumentClick = function (e) {
      t.props.disabled || t.area.contains(e.target) || (t.props.onDismiss(e), e.stopPropagation(), e.stopImmediatePropagation(), e.preventDefault());
    }, t.handleEscape = function (e) {
      t.props.disabled || 27 == e.keyCode && (t.props.onDismiss(e), e.stopPropagation());
    }, t;
  }

  e.Dismissible = s, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});